module.exports = __webpack_public_path__ + "static/media/10.cef0fd43.jpeg";